<template>
  <div class="data-list-container">
    <inventory-summery :module_id="44" v-model="maximizeCard"></inventory-summery>
    <!-- <pre>{{inventoryList[0]}}</pre>  -->
    <vs-card v-if="inventoryList.length != 0">
      <vs-row class="flex items-center">
        <vs-col class="flex" vs-lg="6" vs-xs="12">
          <vs-tooltip text="Grid View" position="top" >
            <a
              @click="viewingType('grid')"
              class="view-anchor"
              :class="{ active: gridView == true }"
            >
              <span class="material-icons">grid_view</span>
            </a>
          </vs-tooltip>
          <vs-tooltip text="List View" position="top" >
            <a
              @click="viewingType('list')"
              class="view-anchor"
              :class="{ active: listView == true }"
            >
              <span class="material-icons">list</span>
            </a>
          </vs-tooltip>
          <vs-tooltip text="Filter" position="top" >
            <a class="view-anchor" @click="filter_list()">
              <span class="material-icons"> filter_list </span>
            </a>
          </vs-tooltip>
        </vs-col>
        <vs-col class="flex" vs-lg="6" vs-xs="12">
          <vs-button
            class="block ml-auto"
            color="primary"
            style="border-radius: 5px"
            @click="createNewInventory()"
            v-if="checkCreatePermission()"
            >Create New Inventory</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-card>
    <div v-if="filter == true">
      <InventoryFilter @filterObject="filterObject"
      @resetFilter="resetFilter"
      ></InventoryFilter>
    </div>
      <vx-card
      v-if="listView == true || gridView == true"
      title="Search View"
      class="mb-4"
    >
      <vs-row>
        <vs-col
          vs-lg="12"
          vs-sm="12"
          vs-xs="12"
          vs-type="flex"
          class="flex-wrap"
          vs-align="center"
        >
          <vs-row>
            <vs-col vs-lg="3" vs-sm="12" vs-xs="12" class="p-1">
              <vs-input
                placeholder="Search"
                class="w-full"
                v-model="search"
                @keyup="searchFun"
                style="width: 100%"
              />
            </vs-col>
            <vs-col vs-type="flex" vs-lg="3" vs-sm="12" vs-xs="12" class="p-1">
              <vs-tooltip color="primary" text="Reset Search" position="top">
                <vs-button
                  type="border"
                  icon-pack="feather"
                  icon="icon-refresh-cw"
                  @click="resetSearch"
                ></vs-button>
              </vs-tooltip>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vx-card>
    <!-- when no rooms to display -->
    <vs-card class="no-assets-card" v-if="inventoryList.length == 0">
      <svg
        class="noRoomsSvg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
        style="enable-background: new 0 0 24 24"
        xml:space="preserve"
      >
        <g>
          <path
            class="st0"
            d="M6.5793114,18.46418h3.1201229v0.9283733H6.5793114V18.46418z"
          />
          <path
            class="st0"
            d="M9.6994343,17.7531662v-1.457653c0-0.8616076-0.6984539-1.5600605-1.5600615-1.5600605   s-1.5600615,0.6984529-1.5600615,1.5600605v0.7466373H5.9031835v0.7110157H9.6994343z"
          />
          <path
            class="st0"
            d="M10.410449,19.3925533h1.2045546v0.7028618H5.9031835v0.7110138h12.134655v-0.7110138h-5.7118196v-0.7028618   h1.2045546V18.46418H10.410449V19.3925533z"
          />
          <path
            class="st0"
            d="M13.5305729,16.2955132c0-0.8616076-0.6984539-1.5600605-1.5600624-1.5600605   c-0.8616076,0-1.5600615,0.6984529-1.5600615,1.5600605v1.457653h3.1201229L13.5305729,16.2955132z"
          />
          <path
            class="st0"
            d="M14.2415876,18.46418h3.120122v0.9283733h-3.1201229L14.2415876,18.46418z"
          />
          <path
            class="st0"
            d="M18.037838,17.7531662v-0.7110157h-0.6761284v-0.7466373c0-0.8616076-0.6984539-1.5600605-1.5600615-1.5600605   s-1.5600615,0.6984529-1.5600615,1.5600605v1.457653H18.037838z"
          />
        </g>
        <g>
          <polygon
            class="st0"
            points="13.9266357,13.0211487 14.1452026,13.0211487 14.1452026,12.8581238  "
          />
          <path
            class="st0"
            d="M12.258667,10.5226135c-0.1028442-0.0256958-0.2049561-0.0571899-0.3128052-0.0521851   c-0.314209,0.0147705-0.6083984,0.1641846-0.8071289,0.4100952l-0.5530396-0.4468994   c0.3262939-0.4036865,0.8099365-0.6491699,1.3269043-0.6734009c0.3599854-0.0170288,0.7108765,0.0805054,1.0151978,0.2631836   l1.2174072-0.9082642V8.6717834H9.7958374v3.6883545L12.258667,10.5226135z"
          />
        </g>
        <g>
          <polygon
            class="st0"
            points="5.9309082,15.2436829 5.9309082,10.4154968 3.9309082,10.4154968 3.9309082,16.7358704  "
          />
          <polygon
            class="st0"
            points="18.0695801,19.8061218 5.9309082,19.8061218 5.9309082,18.9866638 3.9309082,20.4787903    3.9309082,21.8061218 20.0695801,21.8061218 20.0695801,10.4154968 18.0695801,10.4154968  "
          />
        </g>
        <g>
          <polygon
            class="st0"
            points="12.0002441,4.9859314 15.2816162,8.2673035 16.9014282,7.0587463 12.0002441,2.1575623    1.1276245,13.0296326 2.5418091,14.4439392  "
          />
          <polygon
            class="st0"
            points="19.0450439,9.2023621 17.4252319,10.4109192 21.4581909,14.4438782 22.8723755,13.0296936  "
          />
        </g>
        <line
          class="st1"
          x1="2.4739285"
          y1="20.8064289"
          x2="21.8611469"
          y2="6.3412781"
        />
      </svg>
      No Inventory
      <vs-button
        class="custom-btn1 my-2"
        color="primary"
        style="border-radius: 5px"
        @click="addNewInventory = true"
                v-if="checkCreatePermission()"

        >Add New Inventory</vs-button
      >
    </vs-card>
    <!-- <pre>{{ room_listing }}</pre> -->

    <!-- grid view -->

    <div v-if="gridView == true">
      <inventory-listing
        :inventoryList="inventoryList"
        @editList="editList"
        @deleteInventory="deleteInventory"
        :checkEditPermission="checkEditPermission()"
    :checkDeletePermission="checkDeletePermission()"
      ></inventory-listing>
    </div>
    <!-- {{listView}} -->
    <inventory-table
    @sortFunc="sortFunc"
      :inventoryList="inventoryList"
      v-if="inventoryList.length && listView == true"
      @editList="editList"
      @deleteInventory="deleteInventory"
      :checkEditPermission="checkEditPermission()"
    :checkDeletePermission="checkDeletePermission()"
    ></inventory-table>
     <vs-row class="mt-2" vs-type="flex" vs-justify="space-between">
      <vs-col
        vs-xs="12"
        vs-sm="6"
        vs-lg="4"
        vs-type="flex"
        vs-justify="start"
        vs-align="center"
      >
        <!-- page limit select view -->
        <ItemsPerTableDropdown
          tableName="inventory_table"
          @change="pageLimit => (pageLimitSet = pageLimit)"
        />
      </vs-col>
      <vs-col vs-xs="12" vs-sm="6" vs-lg="8">
        <pagination
          :meta="meta"
          @page-change="handlePageChange"
          class="cstm_pagination"
          style="float: right"
        />
      </vs-col>
    </vs-row>
    <vs-popup title="Inventory" :active.sync="addNewInventory">
      <InventoryCreate
        @closeSidebar="closeSidebar"
        @createdNewInventory="createdNewInventory"
        :editingObject="editingObject"
        v-if="addNewInventory"
      ></InventoryCreate>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import InventoryFilter from './components/InventoryFilter.vue'
import InventoryCreate from './components/InventoryCreate'
import { inventoryOrRoomListApi } from '@/api/room'
import InventoryListing from './components/InventoryListing'
import InventoryTable from './components/InventoryTable.vue'
import Pagination from '@/components/common/pagination'
import InventorySummery from '../analytics/summeryLIst'
import { PermissionMiddleware } from '../../../mixins/middleware/PermissionMiddleware'

export default {
  name: 'rooms',
  components: {
    vSelect,
    InventoryCreate,
    InventoryListing,
    InventoryTable,
    InventoryFilter,
    Pagination,
    InventorySummery
  },
  watch: {
    pageLimitSet () {
      this.handlePageChange(1)
    }
  },
  mixins:[PermissionMiddleware],

  data () {
    return {
      // addSideBar: false,
      search: '',
      sorting_obj: {},
      pageLimitSet: 5,
      maximizeCard:true,
      addNewInventory: false,
      inventoryActive: false,
      gridView: true,
      listView: false,
      selectedMoreInv: [],
      inventoryList: [],
      editingObject: null,
      filter: false,
      filterObj:{},
      meta: {
        total: '',
        limit: 10,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: ''
      }
    }
  },
  created () {
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Rooms and Inventory', false, false, true)
    }
    // this.checkingQuery('/pages/inventory')
    // this.fetchInventoryList()
  },
  methods: {
    async searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async vm => {
      try {
        vm.fetchInventoryList(vm.meta)
      } catch (e) {
        console.log(e)
      }
    }, 1500),
    sortFunc (data) {
      this.sorting_obj = data
      const query_params = {
        current_page: this.meta.current_page,
        ...data,
        table_name: 'inventory_table'
      }
      this.fetchInventoryList(query_params)
    },
    handlePageChange (page) {

      this.meta.current_page = page
      // this.fetchQuestionBankList()


      /* this.$router.replace({
        path:'/pages/inventory',
        query:{page:this.meta.current_page}
      }).catch(() => {}) */

      this.fetchInventoryList(this.meta, this.filterObj)

    },
    resetFilter () {
      setTimeout(() => {
        this.fetchInventoryList(this.meta)
      }, 0)

    },
    filterObject (filterObject) {
      this.filterObj = filterObject
      this.fetchInventoryList(this.meta, filterObject)
    },
    filter_list () {
      this.filter = !this.filter
    },
    createNewInventory () {
      this.editingObject = null
      this.addNewInventory = true
    },
    createdNewInventory (obj, assets_id = null) {


      if (assets_id) {
        const index = this.inventoryList.findIndex(
          (ele) => ele.assets_id === assets_id
        )

        this.setUpadtedInventory(index, obj)

      } else {

        obj.defaultImage = obj.asset_images.filter(eachImage => {
          return eachImage.is_default === '1'
        })
        this.inventoryList.push(obj)
      }
      setTimeout(() => {
        this.addNewInventory = false
      }, 0)
    },
    editList (item) {
      this.editingObject = item
      this.addNewInventory = true


    },
    deleteInventory (index) {
      this.inventoryList.splice(index, 1)

      if (this.inventoryList.length === 0 && !this.meta.next_page_url) {
        this.handlePageChange(this.meta.current_page - 1)
      } else {
        this.handlePageChange(this.meta.current_page)
      }
    },
    closeSidebar (obj) {
      if (obj === false) {
        setTimeout(() => {
          this.addNewInventory = false
        }, 0)
        // this.addNewInventory = false
      }
    },
    resetSearch () {
      this.search = null
      this.fetchInventoryList(1)
    },
    async fetchInventoryList (query_params, filterData = null) {
      try {
        this.$vs.loading({
          text: 'Fetching Inventory List'
        })
        const customer_id = this.$store.getters.customerId
        let payload = {}
        payload = {
          filters: filterData
        }
        payload.limit = this.pageLimitSet
        payload.search = this.search

        query_params = {...query_params, ...this.sorting_obj}
        query_params.table_name = 'inventory_table'

        const responseList = await inventoryOrRoomListApi(
          customer_id,
          'Inventory',
          query_params,
          payload
        )
        this.inventoryList = responseList.data.data.assets_list

        this.inventoryList = this.inventoryList.map(ele => {

          ele.suitable_for = ele.asset_tags.map((ele) => {
            return ele.tag_name
          }).join(', ')

          ele.inventory_type_text = !ele.inventory_type ? 'Removal' : 'Non Removal'

          return {
            ...ele,
            defaultImage:ele.asset_images.filter(eachImage => {
              return eachImage.is_default === '1'
            })

          }
        })

        this.meta = responseList.data.data.meta

      } catch (error) {
        console.log(error)
      } finally {
        this.$vs.loading.close()
      }
    },
    handlcreateSidebar () {
      this.editing_index = null
      this.addSideBar = false
      this.defaultInit()
    },
    addTags () {
      this.suitable_for.push(this.suitable)
      this.suitable = ''
    },
    deleteTag (index) {
      this.suitable_for.splice(index, 1)
    },
    /*   deleteInventory (index) {
      this.inventory_array.splice(index, 1)
    }, */

    defaultInit () {
      this.number_of_person = ''
      this.room_name = ''
      this.suitable_for = []
      this.inventory_array = []
      this.price_booking = ''
      this.$refs.imageupload.value = ''
      this.image_upload.length = 0
    },
    viewingType (type) {
      if (type === 'grid') {
        this.gridView = true
        this.listView = false
      } else if (type === 'list') {
        this.gridView = false
        this.listView = true
      }
    },
    setUpadtedInventory (index, obj) {
      //


      this.inventoryList[index].name = obj.name
      this.inventoryList[index].asset_images = obj.asset_images
      this.inventoryList[index].asset_tags = obj.asset_tags
      this.inventoryList[index].asset_types = obj.asset_types
      this.inventoryList[index].assets_id = obj.assets_id
      this.inventoryList[index].inventory_type = obj.inventory_type
      this.inventoryList[index].asset_details = obj.asset_details
      this.inventoryList[index].number_of_person = obj.number_of_person
      this.inventoryList[index].price = obj.price
      this.inventoryList[index].price_type = obj.price_type
      this.inventoryList[index].quantity = obj.quantity
      this.inventoryList[index].defaultImage = obj.asset_images.filter(eachImage => {
        return eachImage.is_default === '1'
      })
    }

    /*   roomDetails (index) {


      this.$router.push({
        name: 'rooms-details',
        params: { roomDetail: this.room_listing[index] }
      })
    } */
  }
}
</script>
<style>
.vs-component .vs-dropdown--item,
.vs-dropdown--item-link,
.vs-dropdown--group-label,
.vs-component .vs-dropdown--group .marginIcon {
  font-weight: 500 !important;
}
.vs-sidebar-position-right {
  width: 375px !important;
  max-width: 400px !important;
  z-index: 111111111111111 !important;
  /*height: auto !important;*/
  /*position: absolute;*/
  /*top: 12%;*/
}

.flatpickr-calendar.open {
  z-index: 111111111111115 !important;
}

.vs-notifications {
  z-index: 1111111111111151111 !important;
}

.gb-vue-timeline-update__title {
  font-size: 14px !important;
  margin-left: -12px !important;
}

.gb-vue-timeline-update__ago {
  margin-right: -9%;
}
.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  box-shadow: 7px 3px 15px #c7c6c6;
}
/* .ag-header-cell {
    padding: 2px !important;
  } */

/* .custom-btn1 {
  padding: 5px 10px !important;
  font-size: 12px;
  border-radius: 0px;
  font-weight: 600;
} */
.ag-pivot-off .ag-header-group-cell {
  /* font-size: 50px; */
  color: red;
}
.ag-grid-table {
  min-height: 250px;
}

li {
  list-style: none;
}
#selectdynamic {
  width: 100%;
  height: 38px;
  border-radius: 4px;
}
#dynamicradio {
  margin-right: 10px;
}

.requiredInput .vs-input--label:after {
  content: " *";
  color: red;
}

/* .vs-sidebar .vs-sidebar--items {
  overflow-y: scroll;
} */

.cstm-asset-card {
  position: relative;
  padding: 10px;
}
.no-assets-card {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80vh;
  text-align: center;
}
.no-assets-card .vs-card--content {
  display: inherit;
  flex-direction: column;
  align-items: center;
}
.view-anchor {
  cursor: pointer;
  color: #898989;
  padding: 5px;
}
.view-anchor.active {
  color: rgba(var(--vs-primary), 1);
}
.cstm-asset-card .vs-card--content {
  margin-bottom: 0;
}
.cstm-asset-card .room-img {
  border-radius: 5px;
  width: 100%;
  height: 250px;
  object-fit: contain;
  border: 1px solid #e9e9e9;
  padding: 5px;
}
.cstm-asset-card .vs-con-dropdown.parent-dropdown {
  position: absolute;
  top: 290px;
  right: 20px;
}
.cstm-asset-card .numbers {
  display: inherit;
  color: rgba(var(--vs-primary), 1);
  align-content: center;
  font-size: 14px;
  font-weight: bold;
}
.cstm-asset-card .numbers * {
  display: inherit;
  align-items: center;
}
.assets-list {
  margin-top: 32px;
}
.assets-list li {
  color: #8998aa;
  font-weight: 600;
  font-size: 12px;
  margin: 6px 12px;
  display: inline-block;
  vertical-align: top;
  position: relative;
}
.assets-list li::before {
  content: '\2023';
  position: absolute;
  top: 0;
  left: -6px;
}
.assets-list .material-icons {
  width: 12px;
  color: #c7cfd6;
}
.assets-list .heading {
  font-weight: bold;
  margin-left: 15px;
  color: #8998aa;
}
.inventory-modal {
  z-index: 100000;
}
.assets-table .assets-img {
  width: 80px;
  height: 70px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #898989;
  padding: 2px;
}
.assets-table th {
  background-color: #e6e4e4;
}
.assets-table td {
  border-bottom: 1px solid #e6e4e4;
}
.noRoomsSvg {
  opacity: 0.5;
  width: 300px;
  height: 300px;
}
.noRoomsSvg .st0 {
  fill: #626262;
}
.noRoomsSvg .st1 {
  fill: none;
  stroke: #626262;
  stroke-width: 2;
  stroke-miterlimit: 10;
}
.upload-holder {
  position: relative;
  display: inline-block;
}
.upload-holder input[type="file"] {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 1;
  opacity: 0;
}
.upload-holder .upload-btn {
  width: 100%;
}
img.preview {
  width: 100%;
  height: 150px;
  object-fit: cover;
}
.assets-table img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 10px;
}
.inventory-modal .assets-table .td-check {
  display: none;
}
.suitableTagHolder,
.inventory-holder {
  display: flex;
  flex-wrap: wrap;
  /* border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px; */
  /* margin: 32px 0 14px; */
  position: relative;
}
/* .suitableTagHolder label,
.inventory-holder label {
  position: absolute;
  top: -19px;
} */
/* .suitableTagHolder:focus-within {
  box-shadow: 0 3px 10px 0 rgb(0 0 0 / 15%);
  border: 1px solid rgb(65, 207, 221);
} */
.focusHolder:focus-within label {
  color: rgba(var(--vs-primary), 1);
}
.suitableTagHolder input {
  border: none;
  padding: 0.7rem;
  background: transparent;
  flex: 1;
}
.tag-badge {
  background-color: #f0f0f0;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
  padding: 0 5px;
  margin: 5px;
  display: inline-flex;
  align-items: center;
  font-size: 0.9rem;
  min-height: 26px;
}
span.tag-badge a {
  font-size: 25px;
  width: 14px;
  height: 14px;
  line-height: 14px;
  display: inline-flex;
  margin-left: 5px;
  cursor: pointer;
  color: #626262;
  opacity: 0.5;
}
.inventory-holder {
  min-height: 37.6px;
}
.inventory-holder .addbtn {
  position: absolute;
  right: 10px;
}


@media (max-width: 768px) {
  .cstm-asset-card .room-img {
    margin-bottom: 50px;
  }
}
</style>
